jQuery(document).ready(function ($) {

    $('.rrssb-buttons a.popup').on('click', function (e) {
        var _this = $(this);
        window.open(_this.attr('href'), _this.find('.text').html(), "width=580,height=470");
        e.preventDefault();
    });
});